// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.tech {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.tech_img {
  width: 100%;
}
.tech .tech_settings_1 {
  position: absolute;
  left: 0;
  animation: spin 15s linear infinite;
}
.tech .tech_settings_2 {
  position: absolute;
  right: 0;
  width: 80px;
  top: -100px;
  animation: spin 11s linear infinite;
}
.tech .tech_settings_3 {
  position: absolute;
  left: 0;
  left: 22%;
  bottom: 55%;
  width: 80px;
  animation: spin 6s linear infinite;
}
.tech .tech_settings_4 {
  position: absolute;
  right: 0;
  bottom: 50%;
  animation: spin 8s linear infinite;
}
.tech_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.tech_wrapper h1 {
  font-size: 42px;
  font-style: normal;
  font-weight: 500;
  color: #6b6b6b;
  margin-bottom: 24px;
  text-align: center;
  line-height: 1;
}
.tech_wrapper p {
  color: #6b6b6b;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.28px;
  margin-bottom: 150px;
}
@media (max-width: 1100px) {
  .tech_wrapper p {
    margin-bottom: 80px;
  }
}

@media (max-width: 1100px) {
  .tech_settings_1,
  .tech_settings_2,
  .tech_settings_3,
  .tech_settings_4 {
    display: none;
  }
  .tech {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/technical-maintenance/technikal-maintenance.scss"],"names":[],"mappings":"AAAA;EACI;IACI,uBAAA;EACN;EACE;IACI,yBAAA;EACN;AACF;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,WAAA;AAAR;AAGI;EACI,kBAAA;EACA,OAAA;EACA,mCAAA;AADR;AAGI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,mCAAA;AADR;AAGI;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;AADR;AAGI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kCAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAFR;AAIQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAFZ;AAIQ;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;AAFZ;AAIY;EAXJ;IAYQ,mBAAA;EADd;AACF;;AAMA;EACI;;;;IAII,aAAA;EAHN;EAME;IACI,aAAA;EAJN;AACF","sourcesContent":["@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.tech {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n\n    &_img{\n        width: 100%;\n    }\n\n    .tech_settings_1 {\n        position: absolute;\n        left: 0;\n        animation: spin 15s linear infinite;\n    }\n    .tech_settings_2 {\n        position: absolute;\n        right: 0;\n        width: 80px;\n        top: -100px;\n        animation: spin 11s linear infinite;\n    }\n    .tech_settings_3 {\n        position: absolute;\n        left: 0;\n        left: 22%;\n        bottom: 55%;\n        width: 80px;\n        animation: spin 6s linear infinite;\n    }\n    .tech_settings_4 {\n        position: absolute;\n        right: 0;\n        bottom: 50%;\n        animation: spin 8s linear infinite;\n    }\n\n    &_wrapper {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        position: relative;\n\n        h1 {\n            font-size: 42px;\n            font-style: normal;\n            font-weight: 500;\n            color: #6b6b6b;\n            margin-bottom: 24px;\n            text-align: center;\n            line-height: 1;\n        }\n        p {\n            color: #6b6b6b;\n            text-align: center;\n            font-family: Inter;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n            letter-spacing: 1.28px;\n            margin-bottom: 150px;\n\n            @media (max-width: 1100px) {\n                margin-bottom: 80px;\n            }\n        }\n    }\n}\n\n@media (max-width: 1100px) {\n    .tech_settings_1,\n    .tech_settings_2,\n    .tech_settings_3,\n    .tech_settings_4 {\n        display: none;\n    }\n\n    .tech{\n        padding: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
